import ApiConstant from "../../constants/api.constants";
import api from "../api";

const getComplaintCategory = async () => {  
    try {
        const ComplaintCategory: any = await api
        .get(ApiConstant.getComplaintCategory)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get complaint category data.', error);
         });
        const response = ComplaintCategory != null ? ComplaintCategory : null;        
        return response;
    }
    catch (e) {
        console.log('error in getComplaintCategory');
        return [];
    } 
};

const addCategory = async (complaintCategories: any) => {
    try {
      const addCategory: any = await api
        .post(ApiConstant.createComplaintCategory, complaintCategories)
        .then((result: any) => {
          if (result) 
            return result.data;
          else 
          return null;
        })
        .catch(function (error: any) {
          console.error("error creating complaint category data.", error);
        });
      const response = addCategory != null ? addCategory : null;
      return response;
    } catch {
      console.log("error in add user complaint category");
      return [];
    }
  };

  const updateComplaintCategory = async (data: any) => {
    try {
        const res: any = await api
        .put(ApiConstant.updateComplaintCategory, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating complaint category', error);
         });
        const response = res != null ? res : null;        
        return response;
    }
    catch
    {
        console.log('error in update complaint category');
        return [];
    }
};

const deleteComplaintCategory = async (complaintCategoryId: any) => {
  try {
    const response = await api
      .delete(ApiConstant.deleteComplaintCategory + complaintCategoryId)
      .then((res: any) => {
        if (res && res.status === 200) {
          return true; 
        } else {
          return false;
        }
      })
      .catch(function (error: any) {
        console.error("Error deleting complaint category data:", error);
        return false; 
      });     
    return response;
  } catch (e) {
    console.log("Error in delete complaint category", e);
    return false; 
  }
};


const categories = {
    getComplaintCategory,
    addCategory,
    updateComplaintCategory,
    deleteComplaintCategory,
}

export default categories;